import { RefObject } from "react"
import { TourModalStep } from "../TourModal"

export const DISPOSAL_REGISTRAR_CREATE_MODAL_TOUR_ID = "disposal_registrar_create_modal"

export interface DisposalRegistrarCreateModalTourRefs {
    requiredSettings: RefObject<HTMLDivElement>
    additionalSettings: RefObject<HTMLDivElement>
    rvActions: RefObject<HTMLDivElement>
    okButton: RefObject<HTMLButtonElement>
}

export const getDisposalRegistrarCreateModalTourSteps = (refs: DisposalRegistrarCreateModalTourRefs): TourModalStep[] => [
    {
        target: () => refs.requiredSettings.current,
        description: "Для настройки регистратора выбытия заполните обязательные поля: Название - Произвольное название регистратора; Контрагент - аптека, к которой привязан данный регистратор; Драйвер - выбрать из списка драйвер, соответствующий регистратору; Логин, Пароль, Сервер и Порт - параметры подключения для доступа к регистратору.",
        placement: "bottom",
    },
    {
        target: () => refs.additionalSettings.current,
        description: "Дополнительные настройки: Необходимо указать «Регистратор включен» и выбрать один из двух способов отправки: «Автоматическая отправка в РВ напрямую», либо «Автоматическая отправка в РВ через КИЗ-сервер». Если включен признак «Отправлять схемы документовов РН и ПТ через данный РВ», то для отправки через РВ требуется дополнительно настроить схему 10531 в конструкторе для документов РН и ПТ",
        placement: "bottom",
    },
    {
        target: () => refs.rvActions.current,
        description: "Здесь можно проверить работоспособность регистратора выбытия и посмотреть его свойства. Для корректной работы кнопок необходимо, чтобы обязательные поля были корректно настроены, и «Регистратор включён» был активным.",
        placement: "top",
    },
    {
        target: () => refs.okButton.current,
        description: "Важно! После сохранения необходимо указать настроенный регистратор выбытия в разделе настройках Кассовых аппаратов (в строке «Регистратор выбытия»).",
        placement: "top",
    },
]
